import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useStateContext } from './StateContext';
import './Header.css';
import { useNavigate } from 'react-router-dom';

function Header({ navigationFunctions }) {
  const navigate = useNavigate();
  const { numDays, limDays, bqValue, progress, limProgress, headerFieldProgressColor, headerFieldDaysColor, deckInfoContext } = useStateContext();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const location = useLocation();
  const [showFields, setShowFields] = useState(false);
  const [showMenuContext, setShowMenuContext] = useState(false);


  useEffect(() => {
    if (deckInfoContext) {
      //console.log('Header effect json: ' + deckInfoContext)
      const deckInfoEncuentro = deckInfoContext ? JSON.parse(deckInfoContext) : {};
      //console.log('Header effect: ', deckInfoEncuentro);
    }
    if (location.pathname !== '/' && location.pathname !== '/CargarPartida' && location.pathname !== '/Prologo' && location.pathname !== '/FAQ' ) {
      setShowFields(true);
    } else {
      setShowFields(false);
    }
    if (location.pathname !== '/' && location.pathname !== '/CargarPartida' && location.pathname !== '/Prologo' && location.pathname !== '/FAQ' && location.pathname !== '/EncuentroEspecial' && location.pathname !== '/Epilogo' ) {
      setShowMenuContext(true);
    } else {
      setShowMenuContext(false);
    }

  }, [deckInfoContext, location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  const encrypt = (text) => {
    const charMap = {
      'a': 'm', 'b': 'n', 'c': 'b', 'd': 'v', 'e': 'c', 'f': 'x', 'g': 'z', 'h': 'l', 'i': 'k', 'j': 'j',
      'k': 'h', 'l': 'g', 'm': 'f', 'n': 'd', 'o': 's', 'p': 'a', 'q': 'q', 'r': 'w', 's': 'e', 't': 'r',
      'u': 't', 'v': 'y', 'w': 'u', 'x': 'i', 'y': 'o', 'z': 'p',
      'A': 'M', 'B': 'N', 'C': 'B', 'D': 'V', 'E': 'C', 'F': 'X', 'G': 'Z', 'H': 'L', 'I': 'K', 'J': 'J',
      'K': 'H', 'L': 'G', 'M': 'F', 'N': 'D', 'O': 'S', 'P': 'A', 'Q': 'Q', 'R': 'W', 'S': 'E', 'T': 'R',
      'U': 'T', 'V': 'Y', 'W': 'U', 'X': 'I', 'Y': 'O', 'Z': 'P',
      '0': '5', '1': '6', '2': '7', '3': '8', '4': '9', '5': '0', '6': '1', '7': '2', '8': '3', '9': '4'
    };

    return text.split('').map(char => charMap[char] || char).join('');
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    } else {
      // Fallback for older browsers, including some iPhones
      let textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';  // Prevent scrolling to the bottom of the page
      textarea.style.opacity = '0'; // Hide the textarea from view
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      document.body.removeChild(textarea);
    }
  };

  const handleSaveGame = () => {
    toggleMenu();
    const encryptedDeckInfo = encrypt(deckInfoContext);
    copyToClipboard(encryptedDeckInfo);
    setIsSaved(true);
    setTimeout(() => {
      setIsSaved(false);
    }, 6000); // Mostrar aviso por 6 segundos
  };




  const handleEncuentroEspecial = () => {
    toggleMenu();
    navigate('/EncuentroEspecial', { state: { deckInfoContext } });
  };

  const handleCartaTirano = () => {
    toggleMenu();
    const updatedDeckInfoJSON = deckInfoContext;
    const verCartaTirano = true;
    navigate('/CombateTirano', { state: { updatedDeckInfoJSON, verCartaTirano } });
  };

  const handleLoadGame = () => {
    toggleMenu();

    navigate('/CargarPartida');
  };

  const goToFAQ = () => {
    toggleMenu();

    navigate('/FAQ');
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">
          <img src="https://firebasestorage.googleapis.com/v0/b/tmbcards-3ec94.appspot.com/o/resources%2Flogo.png?alt=media" alt="Logo" />
        </Link>
      </div>

      {showFields && (
        <div className="header-fields">
          <div className={`field ${headerFieldProgressColor}`}>
            <label>Progreso: </label>
            <span>{progress} / {limProgress}</span>
          </div>
          <div className={`field ${headerFieldDaysColor}`}>
            <label>Días Aventura:  </label>    <br />
            <span> {numDays} / {limDays} </span>
          </div>
          <div className="field">
            <label>BQ:</label>
            <span>{bqValue}</span>
          </div>
        </div>
      )}

      <div className={`menu ${isMenuOpen ? 'open' : ''}`}>
        <button className="close-button" onClick={toggleMenu}>X</button>
        <nav>
          <ul>
            {showFields && showMenuContext && (
              <>
                <li><a href="#" onClick={(e) => { e.preventDefault(); handleEncuentroEspecial(); }}>Añadir encuentro especial</a></li>
                <li><a href="#" onClick={(e) => { e.preventDefault(); handleCartaTirano(); }}>Ver carta del tirano</a></li>
                <li><a href="#" onClick={(e) => { e.preventDefault(); handleSaveGame(); }}>Guardar partida</a></li>
              </>
            )}
            <li>________________</li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); handleLoadGame(); }}>Cargar partida</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); goToFAQ(); }}>FAQ</a></li>
            <li>________________</li>
            <li>
            {/*<a href="https://paypal.me/miguelmsa1?country.x=ES&locale.x=es_ES" target="_blank" rel="noopener noreferrer">
              <img src="https://firebasestorage.googleapis.com/v0/b/tmbcards-3ec94.appspot.com/o/resources%2Fcoffee.png?alt=media" alt="Café" style={{ width: '20px', marginRight: '8px' }} />
              Invítame a un café
            </a>*/}
          </li>
          </ul>
        </nav>
      </div>
      <button className="menu-toggle" onClick={toggleMenu}>
        &#9776; {/* Icono del menú hamburguesa */}
      </button>

      {isSaved && (
        <div className="save-notification">
          Partida guardada en el portapapeles, pega el código de guardado en un lugar seguro.
        </div>
      )}
    </header>
  );
}

export default Header;
